import { render, staticRenderFns } from "./basicComponent.vue?vue&type=template&id=6693a0b2&scoped=true"
import script from "./basicComponent.vue?vue&type=script&lang=js"
export * from "./basicComponent.vue?vue&type=script&lang=js"
import style0 from "./basicComponent.vue?vue&type=style&index=0&id=6693a0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6693a0b2",
  null
  
)

export default component.exports